// import EventEmitter from 'events';
// @ts-ignore
/* eslint-disable */
(function (win, lib) {
    // var emitter = new EventEmitter();
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});
    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    }
    else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }
    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            }
            else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2;
            }
            else {
                dpr = 1;
            }
        }
        else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }
    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' +
            scale +
            ', maximum-scale=' +
            scale +
            ', minimum-scale=' +
            scale +
            ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        }
        else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }
    function refreshRem() {
        var orientation = '';
        var base = '';
        var cw = document.documentElement.clientWidth;
        var sw = window.innerWidth;
        var sh = window.innerHeight;
        var _Width = sw < sh ? sw : sh;
        var _Height = sw >= sh ? sw : sh;
        /* 根据手机的宽度 与 文档的宽度对比 */
        /* 竖屏 */
        if (cw == _Width) {
            base = docEl.getBoundingClientRect().width;
            orientation = 'portrait';
        }
        /* 横屏 让rem的base跟横屏一致 */
        if (cw == _Height || cw / _Height > 0.9) {
            base = _Width;
            orientation = 'landscape';
        }
        /* 半屏 取最小作为基准 */
        if (orientation == '') {
            base = Math.min(docEl.getBoundingClientRect().width, docEl.getBoundingClientRect().height);
        }
        if (base / dpr > 640) {
            base = 640 * dpr;
        }
        console.log('orientation', orientation);
        if (orientation == '') {
            return;
        }
        var rem = base / 18.75;
        // if (rem < 18.75) rem = 18.75;
        if (rem < 17.06)
            rem = 17.06; // 320 / 18.75 = 17.06
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
        flexible.orientation = orientation;
        // emitter.emit('updateRem', rem);
        /* 解决safari 操作栏遮住的问题 */
        // document.documentElement.scrollTop = 0;
    }
    win.addEventListener('resize', function () {
        console.warn('resize');
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            console.warn('pageShow');
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);
    // 监听屏幕旋转
    win.addEventListener('onorientationchange', function (e) {
        console.warn('onorientationchange');
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, true);
    if (doc.readyState === 'complete') {
        console.warn('complete');
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }
    else {
        doc.addEventListener('DOMContentLoaded', function (e) {
            console.warn('DOMContentLoaded');
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }, false);
    }
    console.warn('initRem');
    refreshRem();
    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    };
    flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    };
    // flexible.emitter = emitter;
})(window, window['lib'] || (window['lib'] = {}));
/* eslint-disable no-new */
